import {Component, OnInit} from '@angular/core';
import {BackToHomeComponent} from '../../components/back-to-home/back-to-home.component';
import {Router, RouterLink} from '@angular/router';
import {SwitcherComponent} from '../../components/switcher/switcher.component';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {RecaptchaV3Service} from '../../core/services/recaptcha/recaptcha-v3-service';
import {SignUpService} from '../../core/services/signup/sign-up.service';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-register.component',
  imports: [
    BackToHomeComponent,
    RouterLink,
    SwitcherComponent,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit {

  signUpForm!: FormGroup;
  isLoading = false;
  errorMessage = '';

  constructor(
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly signUpService: SignUpService,
    private readonly recaptchaService: RecaptchaV3Service
  ) {
  }

  ngOnInit(): void {
    this.initForms();
  }

  initForms(): void {
    this.signUpForm = this.formBuilder.group({
      realName: ['', Validators.required, Validators.minLength(4), Validators.maxLength(128), Validators.pattern('^[A-ZÀ-Ÿ][a-zà-ÿ]+\\s[A-ZÀ-Ÿa-zà-ÿ]+(?:\\s[A-ZÀ-Ÿa-zà-ÿ]+)*$')],
      userName: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(128)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(32), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$&+,:;=?@#|\'<>.^*()%!-])[a-zA-Z\\d$&+,:;=?@#|\'<>.^*()%!-]{10,}$')]],
      birthday: ['', Validators.required],
      agreeTerms: [false]
    })
  }

  onSignUpSubmit(): void {
    if (this.signUpForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    if (!this.signUpForm.get('agreeTerms')?.value) {
      this.isLoading = false;
      this.errorMessage = 'SIGNUP.ERROR.AGREE_TERMS';
      return;
    }

    this.recaptchaService.execute('signup',(recaptchaToken) => {
      this.signUpService.signUpUser({
        realName: this.signUpForm.get('realName')?.value,
        email: this.signUpForm.get('email')?.value,
        password: this.signUpForm.get('password')?.value,
        userName: this.signUpForm.get('userName')?.value,
        birthday: this.signUpForm.get('birthday')?.value
      }, recaptchaToken).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigateByUrl('/login');
        },
        error: (error) => {
          this.isLoading = false;
          this.errorMessage = error.error.message;
        }
      });
    });
  }

}
